<template>
  <section class="section">
    <h3 class="section-header">Recent Videos</h3>
    <div class="video-list grid grid-cols-3 sm-grid-cols-1 md-grid-cols-2 lg-grid-cols-2 xl-grid-cols-3">
        <router-link v-for="video in videos" :key="video.id" :to="{ name: 'video-detail', params: { slug: video.slug }}" class="video-preview">
            <img :src="video.thumbnail" :alt="video.title">
            <h3 class="video-title">{{ video.title }}</h3>
            <ul class="video-info">
                <li>{{ video.publishedDate }}</li>
                <li>{{ video.views }} views</li>
            </ul>
        </router-link>
    </div>
  </section>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import VideoService from '@/services/VideoService';

export default defineComponent({
  name: 'RecentVideosSection',
  props: {
      count: {
          type: Number,
          required: true
      }
  },
  data() {
    const recentVideos = VideoService.getRecentVideos(this.count);    
    return {
        videos: recentVideos,
    }
  }
});
</script>
